import {
	CreateBase,
	required,
	SimpleForm,
	TextInput,
	useCreateSuggestionContext
} from 'react-admin';
import CloseIcon from '@mui/icons-material/Close';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Stack
} from '@mui/material';
import { GoogleAutocompleteInput } from '../../../misc/GoogleAutocompleteInput';
import { INPUT_SOURCE } from '../../constants';
import { BuildingType } from '../../types';

export const FastCreateBuilding = () => {
	const { filter, onCancel, onCreate } = useCreateSuggestionContext();

	const transform = (data: BuildingType) => ({
		...data,
		in_operation: true,
		function_type: 1
	});

	const onBuildingCreate = (buildingName: string) => {
		onCreate(buildingName);
	};

	return (
		<>
			<Dialog
				sx={{
					zIndex: 999
				}}
				open
				onClose={onCancel}
				slotProps={{
					paper: {
						sx: {
							width: 400
						}
					}
				}}
			>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
				>
					<DialogTitle sx={{ m: 0, p: 2 }}>Створити будівлю</DialogTitle>
					<IconButton
						aria-label="close"
						onClick={onCancel}
						sx={theme => ({
							color: theme.palette.grey[500],
							marginRight: 1
						})}
					>
						<CloseIcon />
					</IconButton>
				</Stack>
				<DialogContent sx={{ p: 0 }} dividers>
					<CreateBase
						redirect={false}
						resource="buildings"
						transform={transform}
						mutationOptions={{
							onSuccess: buildingName => {
								onBuildingCreate(buildingName);
							}
						}}
					>
						<SimpleForm defaultValues={{ name: filter }}>
							<Stack width="100%">
								<TextInput
									source={INPUT_SOURCE.NAME}
									helperText={false}
									validate={required()}
								/>
								<GoogleAutocompleteInput isRequired={true} />
							</Stack>
						</SimpleForm>
					</CreateBase>
				</DialogContent>
			</Dialog>
		</>
	);
};
